import { BgColors } from "../constants";
import { SettingsItem } from "./SettingsItem";

const Color = ({ onClick = () => null, selected = false, value = null }) => (
  <div
    className={`
    transition duration-100 ease-in-out
    rounded-full
    ${selected ? "border" : ""}
    ${selected ? "border-gray-600" : ""}
    h-20
    w-20
    flex
    items-center
    justify-center
    p-1
    hover:bg-gray-100
  `}
  >
    <div
      className={`
      h-14
      w-14
      rounded-full
      cursor-pointer
      shadow-inner
      
    `}
      style={{ background: value }}
      onClick={onClick}
    />
  </div>
);

export const ColorSetting = ({
  className = "",
  onChange = () => false,
  value = null,
}) => {
  return (
    <SettingsItem title="Color" className={className}>
      <div className="grid grid-cols-4 gap-x-4 pt-2">
        {Object.keys(BgColors).map((color) => (
          <Color
            key={BgColors[color]}
            onClick={() => onChange(BgColors[color])}
            selected={value === BgColors[color]}
            value={BgColors[color]}
          />
        ))}
      </div>
    </SettingsItem>
  );
};
